'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const getItemSelectionTitle = _ref => {
  let {
    items,
    itemClaims,
    translations
  } = _ref;
  const {
    claimsSelectionTitleLine2Item,
    claimsSelectionTitleLine2ItemItemsSelected,
    claimsSelectionTitleLine2ItemNoEligibility,
    claimsSelectionTitleItem,
    claimsSelectionTitleItemItemsSelected,
    claimsSelectionTitleItemNoEligibility
  } = translations;
  if (!items) return {
    title: null,
    subtitle: null
  };
  const totalClaimableItemQuantity = Object.keys(items).reduce((total, uid) => total + (items[uid].maxClaimableQuantity ?? 0), 0);
  let title = claimsSelectionTitleItem;
  let subtitle = claimsSelectionTitleLine2Item;
  if (totalClaimableItemQuantity === 0) {
    title = claimsSelectionTitleItemNoEligibility;
    subtitle = claimsSelectionTitleLine2ItemNoEligibility;
  } else if (Object.keys(itemClaims).length) {
    title = claimsSelectionTitleItemItemsSelected;
    subtitle = claimsSelectionTitleLine2ItemItemsSelected;
  }
  return {
    title,
    subtitle
  };
};

exports["default"] = getItemSelectionTitle;
